import * as swcHelpers from '@swc/helpers';
import { parseBloomreachContent, parseBloomreachMeta, getCommonParams } from './helpers/helpers.js';

function useBloomreachPageable({ page , component  }) {
    const { pageable  } = component.getModels();
    if (!pageable || !pageable.items) {
        return {
            refs: pageable === null || pageable === void 0 ? void 0 : pageable.items,
            data: {
                meta: {},
                content: {
                    items: []
                }
            }
        };
    }
    const documents = pageable.items.map((ref)=>page.getContent(ref)
    );
    const items = documents.map((doc)=>{
        return swcHelpers.objectSpread({}, page.isPreview() ? {
            document: doc
        } : {}, parseBloomreachContent(doc === null || doc === void 0 ? void 0 : doc.getData()));
    });
    const meta = parseBloomreachMeta(component.getParameters());
    const commonParams = getCommonParams(meta);
    return {
        refs: pageable.items,
        data: swcHelpers.objectSpread({
            meta,
            content: {
                items
            }
        }, commonParams)
    };
}

export { useBloomreachPageable };
//# sourceMappingURL=use-bloomreach-pageable.js.map
